import BaseEntityDto from "@/models/Shared/BaseEntityDto";
import GeoPoint from "@/models/Shared/GeoPoint";
import IAddressLine from "@/models/Shared/IAddressLine";

export default class CompanyAddressDto extends BaseEntityDto implements IAddressLine {
    buildingNameNumber = '';
    streetRoadBlock = '';
    locality = '';
    cityTown = '';
    stateProvinceRegion = '';
    postZipCode = '';
    countryCode = '';
    geometry: GeoPoint = new GeoPoint();
    isExactGeo: boolean;
    types: string[] = []
}